import api from "@/services/api";
import type { GgPerguntaDto } from "./genteGestao";

export interface PesquisaPublicaMeta {
  id: string;
  titulo: string;
  descricao: string | null;
  nomeEmpresa: string;
  modoPrivacidade: string;
  dataFim: string | null;
  tempoEstimadoMinutos: number;
  privacidade: { titulo: string; corpo: string; lgpd: string };
}

export interface PesquisaPublicaPayload {
  success: boolean;
  estado:
    | "pronta"
    | "identificar"
    | "confirmar"
    | "indisponivel"
    | "encerrada"
    | "ja_respondeu"
    | "token_invalido"
    | "nao_encontrado"
    | "limite"
    | "ok"
    | "erro";
  error?: string;
  origem?: "LINK_INDIVIDUAL" | "LINK_GERAL";
  colaboradorNome?: string;
  token?: string;
  pesquisa?: PesquisaPublicaMeta;
  perguntas?: GgPerguntaDto[];
}

export async function fetchPesquisaToken(token: string): Promise<PesquisaPublicaPayload> {
  const { data } = await api.get<PesquisaPublicaPayload>(`/api/pesquisa/nps/r/${encodeURIComponent(token)}`);
  return data;
}

export async function enviarPesquisaToken(
  token: string,
  itens: Array<{ perguntaId: string; valorNumero?: number | null; valorTexto?: string | null }>,
): Promise<PesquisaPublicaPayload> {
  const { data } = await api.post<PesquisaPublicaPayload>(`/api/pesquisa/nps/r/${encodeURIComponent(token)}`, {
    itens,
  });
  return data;
}

export async function fetchPesquisaSlug(slug: string): Promise<PesquisaPublicaPayload> {
  const { data } = await api.get<PesquisaPublicaPayload>(`/api/pesquisa/nps/${encodeURIComponent(slug)}`);
  return data;
}

export async function enviarPesquisaSlug(
  slug: string,
  itens: Array<{ perguntaId: string; valorNumero?: number | null; valorTexto?: string | null }>,
): Promise<PesquisaPublicaPayload> {
  const { data } = await api.post<PesquisaPublicaPayload>(
    `/api/pesquisa/nps/${encodeURIComponent(slug)}/respostas`,
    { itens },
  );
  return data;
}
